import styled from '@emotion/styled';

import { theme } from '../../../theme/theme';
import { useCapabilityValue } from '../../../store/devices/useCapabilityValue';

export function MediaMeta(props) {
  const [speakerTrackValue, ,] = useCapabilityValue({
    deviceId: props.deviceId,
    capabilityId: 'speaker_track',
  });
  const [speakerArtistValue, ,] = useCapabilityValue({
    deviceId: props.deviceId,
    capabilityId: 'speaker_artist',
  });

  return (
    <MediaMeta.Root>
      <MediaMeta.Text title={speakerTrackValue} data-style="track">
        {speakerTrackValue}
      </MediaMeta.Text>
      <MediaMeta.Text title={speakerArtistValue} data-style="artist">
        {speakerArtistValue}
      </MediaMeta.Text>
    </MediaMeta.Root>
  );
}

MediaMeta.Root = styled.div`
  margin-top: 20px;
  max-width: 312px;
`;

MediaMeta.Text = styled.div`
  text-align: center;

  &[data-style='track'] {
    color: ${theme.color.white};
    font-weight: ${theme.fontWeight.medium};
  }

  &[data-style='artist'] {
    color: ${theme.color.white_o_50};
  }
`;
